var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"component":"Contract","template":"page"}},[_c('div',{staticClass:"bg"},[_c('v-card',{staticClass:"holder"},[_c('contract-header',{on:{"onChange":_vm.onChange}}),_vm._v(" "),_c('contracts')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }